import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

const base = environment.api_base_url;
export const clientCreationUrl = () => `${base}/api/client/creation`;

@Injectable({
  providedIn: "root",
})
export class ClientCreationService {
  private http: HttpClient = inject(HttpClient);

  private companyInfoData$= new BehaviorSubject(null);
  private serviceInfoData= new BehaviorSubject(null);
  private accountInfoData= new BehaviorSubject(null);
  private clientCreationLoading$ = new BehaviorSubject(false);

  setCompanyInfoData(data: any) {
    this.companyInfoData$.next(data);
  }

  getCompanyInfoData() {
    return this.companyInfoData$.asObservable();
  }

  setServiceInfoData(data: any) {
    this.serviceInfoData.next(data);
  }

  getServiceInfoData() {
    return this.serviceInfoData.asObservable();
  }

  setAccountInfoData(data: any) {
    this.accountInfoData.next(data);
  }

  getAccountInfoData() {
    return this.accountInfoData.asObservable();
  }

  setClientCreationLoading(loading: boolean = false) {
    this.clientCreationLoading$.next(loading);
  }

  getClientCreationLoading() {
    return this.clientCreationLoading$.asObservable();
  }

  submitClient(clientCreationRequest: any): Observable<any> {
    return this.http.post<any>(clientCreationUrl(), clientCreationRequest);
  }
}
